<template>
  <base-cell class="sales-cell">
    <div class="w-100">
      <div class="d-flex">
        <div class="sales-cell__left-col">
          <base-text
            size="m"
            class="sales__name"
            @click.native="goToClient"
          >
            {{ customerName }}
          </base-text>
          <base-text
            muted
            class="sales__email"
            trim
          >
            {{ email }}
          </base-text>
          <base-text
            v-if="saleTransaction.datetime_to_show"
            size="xs"
            class="sales__date"
          >
            {{ saleTransaction.datetime_to_show | nicedate('small') }}
          </base-text>
          <base-text
            class="sales__order"
          >
            Order {{ order }}
          </base-text>
          <base-text
            v-if="attributed && isAdminMode"
            semibold
            class="attributed text-uppercase"
          >
            {{ attributedDisplayText(attributed) }}
          </base-text>
        </div>
        <div
          class="ml-auto text-right amount"
          :class="{returned: (returned || returnRequested) }"
        >
          <base-text class="amount__number">
            {{ (returned || returnRequested)? '-' : '' }}{{ amount | formatPrice }}
          </base-text>
          <base-text
            v-if="returned"
            size="xs"
            class="returned__label"
          >
            Returned
          </base-text>
          <base-text
            v-else-if="returnRequested"
            size="xs"
            class="returned__label"
          >
            Return requested
          </base-text>
        </div>
      </div>
      <SalesItems
        :items="items"
        :class="{returned__items: (returned || returnRequested)}"
      />
    </div>
  </base-cell>
</template>

<script>
import SalesItems from './SalesItems';

export default {
  name: 'SalesCell',
  components: {
    SalesItems,
  },
  props: {
    customerName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    amount: {
      type: [String, Number],
      default: '',
    },
    order: {
      type: [String, Number],
      default: '',
    },
    returned: {
      type: Boolean,
      default: false,
    },
    returnRequested: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    identifier: {
      type: [String, Number],
      default: '',
    },
    attributed: {
      type: Object,
      default: undefined,
    },
    saleTransaction: { // full reference to the Django api.SaleTransaction given
      type: Object,
      default: undefined,
    },
  },
  computed: {
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
  },
  methods: {
    goToClient() {
      this.$emit('client-clicked', this.identifier);
    },
    attributedDisplayText(attributed) {
      return `${attributed.user.first_name} ${attributed.user.last_name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.sales-cell {
  padding-top: 24px;
  padding-bottom: 24px;
  display: block;
  & .sales-cell__left-col {
    @media screen and (max-width: map-get($breakpoints,'lg')) {
      max-width: 120px;
    }
    & .base-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  &:first-child {
    padding-top: 8px !important;
  }
}
.amount {
  font-family: $font-family-sans-serif-light;
  & .amount__number {
    font-size: 14px;
    line-height: 17px;
  }
}
.returned > *::v-deep {
  color: $orange;
}
.returned__label {
  text-transform: uppercase;
  font-family: $font-family-sans-serif-bold;
  font-size: 0.625rem;
}
.returned__items {
  opacity: 0.8;
}
.sales {
  &__name {
    margin-bottom: 0.35rem;
    cursor: pointer;
    font-family: $font-family-base;
    letter-spacing: -0.00525rem;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.187rem;
  }
  &__date {
    margin-bottom: 0.3125rem;
    font-size: 0.75rem;
    line-height: 0.875rem;
    letter-spacing: 0.1042px;
  }
  &__order {
    margin-bottom: 0.25rem;
    order: 1;
    font-size: 0.75rem;
    line-height: 0.875rem;
    letter-spacing: 0.207211px;
  }
  &__email {
    color: $text-muted-color;
    font-size: 0.75rem;
    line-height: 0.875rem;
    margin-bottom: 0.625rem;
    max-width: 160px; // Temporary fix for email truncation
  }
}
.attributed {
  color: $clementine;
  font-size: 7px;
}
</style>
